// utils/stats.ts
import { getCookie, setCookie } from './cookies';
import { GameStats, GuessDistribution } from '../types/stats';

export const getStats = (): GameStats => {
  try {
    const statsCookie = getCookie('respell_stats');
    if (statsCookie) {
      return JSON.parse(statsCookie) as GameStats;
    }
  } catch {
    // If cookie is corrupted, return default stats
  }
  
  return getDefaultStats();
};

export const updateStats = (win: boolean, attempts?: number): GameStats => {
  const stats = getStats();
  
  const newStats: GameStats = {
    gamesPlayed: stats.gamesPlayed + 1,
    wins: stats.wins + (win ? 1 : 0),
    currentStreak: win ? stats.currentStreak + 1 : 0,
    maxStreak: Math.max(stats.maxStreak, win ? stats.currentStreak + 1 : 0),
    guessDistribution: updateGuessDistribution(stats.guessDistribution, attempts, win),
    lastPlayed: new Date().toISOString()
  };
  
  setCookie('respell_stats', JSON.stringify(newStats));
  return newStats;
};

const getDefaultStats = (): GameStats => ({
  gamesPlayed: 0,
  wins: 0,
  currentStreak: 0,
  maxStreak: 0,
  guessDistribution: {
    1: 0, 2: 0, 3: 0, 4: 0, 5: 0, fail: 0
  }
});

const updateGuessDistribution = (
  distribution: GuessDistribution, 
  attempts: number | undefined, 
  win: boolean
): GuessDistribution => {
  const dist = { ...distribution };
  
  if (win && attempts && attempts >= 1 && attempts <= 5) {
    dist[attempts as keyof GuessDistribution] = dist[attempts as keyof GuessDistribution] + 1;
  } else if (!win) {
    dist.fail = dist.fail + 1;
  }
  
  return dist;
};